/**
 * Documents app behavior for ERP Accelerator.
 */

"use client"

import { useEffect, useState, useRef } from 'react'
import { useRouter } from 'next/navigation'
import { FullPageSpinner } from '@/components/ui/spinner'

/**
 * Handles home page behavior.
 */
export default function HomePage() {
  const router = useRouter()
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const hasRedirected = useRef(false)

  useEffect(() => {
    if (hasRedirected.current) return
    
    // Check if user is authenticated by looking for token
    const token = sessionStorage.getItem('token')
    
    if (token) {
      // Verify token is valid (you could add an API call here to validate)
      setIsAuthenticated(true)
      // Redirect to projects page if authenticated
      hasRedirected.current = true
      router.replace('/workflow/projects')
    } else {
      // Redirect to login page if not authenticated
      hasRedirected.current = true
      router.replace('/login')
    }
    
    setIsLoading(false)
  }, [router])

  // Show loading state while checking authentication
  if (isLoading) {
    return <FullPageSpinner className="min-h-screen" />
  }
  
  return null
}